function mapUserProfileType(type) {
  switch (type) {
    case '2':
      return 'teacher';
    case '3':
      return 'admin';
    default:
      return 'unknown';
  }
}

// Identity is assembled from the query params the host injects. course-assign
// does not always carry a userProfileId in dev, so we fall back to username as
// the distinct id. In hosted environments the host should pass userProfileId so
// the id lines up with combined-assign-review for cross-app comparison.
export default function buildIdentityProps(params, locale) {
  return {
    locale,
    countryCode: params.countryCode || '',
    userProfileId: params.userProfileId || params.username || '',
    userProfileType: mapUserProfileType(params.userProfileType || ''),
    marketRegionId: params.marketRegionId || params.regionId || ''
  };
}



// WEBPACK FOOTER //
// ./analytics/identity.js